import { Input } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { addListingDetailsType } from '~addListing/types';
import { WEEKLY_DURATION } from '~addListing/utils/data';

const WeeklyInputPrice = () => {
  const { t } = useTranslation('app');

  const {
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext<addListingDetailsType>();

  const paymentPlans = watch('paymentPlans') || [];
  const isWeeklyExist = paymentPlans.find(
    (item) => item.duration === WEEKLY_DURATION,
  );
  const value = isWeeklyExist
    ? (paymentPlans.find((item) => item.duration === WEEKLY_DURATION)?.price ??
      '')
    : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const newValue = {
      duration: WEEKLY_DURATION,
      price: Number(value.split(',').join('')) ?? '',
    };
    const updatedPaymentPlans = paymentPlans.map((item) =>
      item.duration === WEEKLY_DURATION ? newValue : item,
    );
    setValue('paymentPlans', updatedPaymentPlans);
  };

  const hasErrors = errors.paymentPlans?.find?.(
    (item) => item?.price?.message === `${WEEKLY_DURATION}`,
  );

  const clearDailyErrors = () => {
    const errorIndex = errors.paymentPlans?.findIndex?.((item) => {
      return item?.price?.message === `${WEEKLY_DURATION}`;
    });

    if (errorIndex === -1) return;

    clearErrors(`paymentPlans.${Number(errorIndex)}.price`);
  };

  if (!isWeeklyExist) return null;

  return (
    <div className="flex flex-col gap-x">
      <div
        className={`${hasErrors ? 'border-red_dark' : 'border-gray'} flex gap-2x border overflow-hidden rounded-[12px] px-1.5x py-x items-center h-[40px] focus-within:border-blue_light_1`}
      >
        <Input
          field={{
            type: 'text',
            placeholder: t('rentWeeklyInputPlaceholder'),
            className:
              'flex-1 text-gray__dark_2 placeholder:text-gray__dark_1 !px-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]',
            onChange: handleChange,
            onFocus: () => clearDailyErrors(),
            value: value ? value?.toLocaleString() : '',
          }}
          className="[&>div]:!border-none flex-1"
        />
        <div className="border-s ps-x border-gray text-body_2">
          <span className="text-gray__dark_2">
            {t('abbreviationEgyptianPound')} /{' '}
          </span>
          <span className="text-gray__dark_1">{t('week')}</span>
        </div>
      </div>
      {hasErrors && <p className="text-red_dark">{t('weeklyPriceRequired')}</p>}
    </div>
  );
};

export default WeeklyInputPrice;
